/** Operator mono stack — Geist Mono with SF Mono fallback. */
export const MONO_FONT = '"Geist Mono", "SF Mono", monospace'
